import angular from 'angular';
import template from './home.tpl.html';

class HomeLandingController {
  /** @ngInject */
  constructor($rootScope) {
  }
}

HomeLandingController.$inject = ["$rootScope"];

class HomeLandingComponent {
  constructor() {
    this.selector = 'home';
    this.template = template;
    this.controller = HomeLandingController;
  }
}

export default angular
.module("home.view", [])
.component("home", new HomeLandingComponent())
.name;
